import React from "react"
import { connect } from "react-redux"
import * as actions from "@store/actions"
import GeocodeRadius from "@components/objects/GeocodeRadius/GeocodeRadius"
import GeocodeSelect from "@components/objects/GeocodeSelect/GeocodeSelect"
import radarDark from "@images/icons/radarDark.svg"
import * as styles from "./SearchLocation.module.scss"

const SearchLocation = ({
  updateResults,
  filters,
  loadBrowserLocation,
  hasLoadedBrowserLocation,
}) => (
  <div className={styles.SearchLocation}>
    <h3>Location</h3>
    <div className={styles.locationBar}>
      <img className={styles.locationIcon} src={radarDark} alt="Your location" />
      <GeocodeSelect
        placeholder="Your Location"
        onChange={updateResults}
        data={filters}
        loadBrowserLocation={loadBrowserLocation}
        hasLoadedBrowserLocation={hasLoadedBrowserLocation}
      />
    </div>
    <div className={styles.slider}>
      <span className={styles.radiusText}>0 - 200 miles range</span>
      <GeocodeRadius updateResults={updateResults} filters={filters} />
    </div>
  </div>
)

const mapStateToProps = (state) => ({
  hasLoadedBrowserLocation: state.search.hasLoadedBrowserLocation,
})

const mapDispatchToProps = (dispatch) => ({
  loadBrowserLocation: () => dispatch(actions.loadBrowserLocation()),
})

export default connect(mapStateToProps, mapDispatchToProps)(SearchLocation)
